import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-stars-input',
  templateUrl: './stars-input.component.html',
  styleUrls: ['./stars-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StarsInputComponent),
      multi: true
    }
  ]
})
export class StarsInputComponent implements ControlValueAccessor {

  @Input() maxStars = 7;

  selectedStars = 0;
  hoveredStars = 0;
  disabled = false;

  get stars(): number[] {
    return Array.from(
      { length: this.maxStars },
      (_, index) => index + 1
    );
  }

  private onChange: (value: string | null) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string | null): void {
    if (!value) {
      this.selectedStars = 0;
      return;
    }

    // Converts "3 Star" -> 3
    const parsedValue = parseInt(value, 10);

    this.selectedStars = Number.isNaN(parsedValue)
      ? 0
      : parsedValue;
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectStar(star: number): void {
    if (this.disabled) {
      return;
    }

    this.selectedStars = star;

    const value = `${star} Star`;

    this.onChange(value);
    this.onTouched();
  }

  setHover(star: number): void {
    if (!this.disabled) {
      this.hoveredStars = star;
    }
  }

  clearHover(): void {
    this.hoveredStars = 0;
  }

  isFilled(star: number): boolean {
    const activeStars = this.hoveredStars || this.selectedStars;
    return star <= activeStars;
  }
}